import { z } from 'zod';

// "Look up" action on the Location & Time tab. The ident is a flight number
// (IATA or ICAO, e.g. "TP123" / "TAP123"); FlightAware resolves it.
export const flightLookupInput = z.object({
  ident: z.string().trim().min(2).max(12),
});

export type FlightLookupInput = z.infer<typeof flightLookupInput>;

const flightEndpointSchema = z.object({
  code: z.string().nullable(),
  name: z.string().nullable(),
  city: z.string().nullable(),
  timezone: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
});

// Normalised advisory summary — a subset of the FlightAware flight object.
// Purely informational (the PRD says it must NOT auto-fill form fields).
export const flightSummarySchema = z.object({
  ident: z.string(),
  operator: z.string().nullable(),
  aircraftType: z.string().nullable(),
  status: z.string().nullable(),
  cancelled: z.boolean(),
  origin: flightEndpointSchema.nullable(),
  destination: flightEndpointSchema.nullable(),
  scheduledOut: z.string().nullable(),
  estimatedOut: z.string().nullable(),
  scheduledIn: z.string().nullable(),
  estimatedIn: z.string().nullable(),
});

export type FlightSummary = z.infer<typeof flightSummarySchema>;

export const flightLookupResult = z.object({
  flights: z.array(flightSummarySchema),
});

export type FlightLookupResult = z.infer<typeof flightLookupResult>;
